import { logoService } from './logoService';
import { Logo } from '../../types';

const sampleLogos: Omit<Logo, 'id' | 'createdAt'>[] = [
  {
    name: 'Tech Startup Logo',
    project: 'StartupX',
    tags: ['tech', 'blue', 'modern'],
    notes: 'Clean minimal design for tech companies',
    claimed: false,
    deleted: false,
    fileUrl: 'https://via.placeholder.com/200x150/3b82f6/ffffff?text=Logo+1',
    fileSize: 25600,
    createdBy: 'admin@agency.com'
  },
  {
    name: 'Organic Food Brand',
    project: 'GreenEats',
    tags: ['organic', 'green', 'nature'],
    notes: 'Earth-friendly branding',
    claimed: false,
    deleted: false,
    fileUrl: 'https://via.placeholder.com/200x150/10b981/ffffff?text=Logo+2',
    fileSize: 31200,
    createdBy: 'admin@agency.com'
  },
  {
    name: 'Fashion Logo',
    project: 'StyleCo',
    tags: ['fashion', 'elegant', 'black'],
    notes: 'Luxury fashion brand identity',
    claimed: false,
    deleted: false,
    fileUrl: 'https://via.placeholder.com/200x150/6b7280/ffffff?text=Logo+3',
    fileSize: 28800,
    createdBy: 'admin@agency.com'
  }
];

export const addSampleLogos = async (): Promise<void> => {
  try {
    console.log('Adding sample logos...');
    for (const logo of sampleLogos) {
      await logoService.addLogo(logo);
    }
    console.log('Sample logos added successfully!');
  } catch (error) {
    console.error('Error adding sample logos:', error);
    throw error;
  }
};